module.exports = __webpack_public_path__ + "img/instagramM.204b8f39.png";